@if (showEditPopup) {
  <div class="k-overlay"></div>
}
@if (showEditPopup) {
  <kendo-window
    [minWidth]="600"
    [title]="(isNew ? 'platform.add' : 'platform.edit') | translate"
    (close)=closePopup()>
    <div class="popupContent">
      <form novalidate class="k-form" [formGroup]="formGroup">
        <kendo-formfield>
          <kendo-floatinglabel text="{{'platform.name' | translate}}*">
            <input kendoTextBox required formControlName="name"/>
          </kendo-floatinglabel>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-floatinglabel text="{{'platform.description' | translate}}">
            <input kendoTextBox formControlName="description"/>
          </kendo-floatinglabel>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-floatinglabel text="{{'platform.productHierarchyIdPlaceholder' | translate}}">
            <input kendoTextBox formControlName="productHierarchyId"/>
          </kendo-floatinglabel>
        </kendo-formfield>
        <br>* {{'common.requiredFields' | translate}}
        </form>
      </div>
      <div class="popup-buttons">
        <button kendoButton (click)="savePopup()">{{"common.save" | translate}}</button>
        <button kendoButton (click)="closePopup()">{{"common.close" | translate}}</button>
      </div>
    </kendo-window>
  }
  @if (itemToRemove) {
    <kendo-dialog
      [title]="'common.removeConfirmation.title' | translate"
      (close)="confirmRemove(false)"
      >
      <p class="dialog-content">
        {{"common.removeConfirmation.message" | translate}} <strong>{{itemToRemove.name}}</strong>?
      </p>
      <kendo-dialog-actions>
        <button kendoButton (click)="confirmRemove(false)">{{"common.no" | translate}}</button>
        <button kendoButton (click)="confirmRemove(true)" [themeColor]="'primary'">{{"common.yes" | translate}}</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  }
  <div class="search">
    <div class="strech">
      <kendo-floatinglabel [text]="'common.search' | translate">
        <kendo-textbox
          [style.width.rem] = "25"
          [clearButton]="true"
          [value]="filterService.searchString"
          (valueChange)="filterService.searchStringChanged(this.gridService.data, $event)"
        ></kendo-textbox>
      </kendo-floatinglabel>
    </div>
    @if (userService.hasAnyRole([roles.PlatformWrite]) | async) {
      <div class="addButton">
        <button kendoButton (click)="addButtonClicked()">
          {{'platform.add' | translate}}
          <svg class="icon"><use xlink:href="/assets/icons/symbol-defs.svg#icon-icons-add"></use></svg>
        </button>
      </div>
    }
  </div>

  <kendo-grid #grid
    [data]="gridService.view"
    [loading]="platformService.loading"
    [resizable]="true"
    [pageSize]="gridService.state.take"
    [skip]="gridService.state.skip"
    [sortable]="true"
    [sort]="gridService.state.sort"
    [pageable]="true"
    [navigable]="true"
    [scrollable]="'none'"
    [kendoGridReactiveEditing]="createFormGroup"
    [editService]="platformService"
    [removeConfirmation]="removeConfirmation"
    (dataStateChange)="gridService.dataStateChange($event)"
    (edit)="editHandler($event)">
    <ng-template kendoGridToolbarTemplate>
      <div class="filter" [ngClass]="{'selectableFilters': filterService.searchString}">
        <span (click)="filterService.filterElements('contains')">{{'common.filter.contains' | translate}}({{filterService.filter.contains}})</span>
        <span (click)="filterService.filterElements('doesnotcontain')">{{'common.filter.notContains' | translate}}({{filterService.filter.notContains}})</span>
        <span (click)="filterService.filterElements('eq')">{{'common.filter.isSame' | translate}}({{filterService.filter.isSame}})</span>
        <span (click)="filterService.filterElements('neq')">{{'common.filter.notSame' | translate}}({{filterService.filter.notSame}})</span>
        <span (click)="filterService.filterElements('startswith')">{{'common.filter.startsWith' | translate}}({{filterService.filter.startsWith}})</span>
        <span (click)="filterService.filterElements('endswith')">{{'common.filter.endsWith' | translate}}({{filterService.filter.endsWith}})</span>
      </div>
      <kendo-grid-column-chooser></kendo-grid-column-chooser>
    </ng-template>
    <kendo-grid-column title="{{'platform.name' | translate}}" field="name" [editable]="false"></kendo-grid-column>
    <kendo-grid-column title="{{'platform.description' | translate}}" field="description" [editable]="false"></kendo-grid-column>
    <kendo-grid-column title="{{'platform.productHierarchyId' | translate}}" field="productHierarchyId" [editable]="false"></kendo-grid-column>
    <kendo-grid-column title="{{'platform.modified' | translate}}" field="modified" [editable]="false" [format]="{datetime: 'short'}"></kendo-grid-column>
    <kendo-grid-column title="{{'platform.modifiedBy' | translate}}" field="modifiedBy" [editable]="false"></kendo-grid-column>
    <kendo-grid-column title="{{'platform.created' | translate}}" field="created" [editable]="false" [format]="{datetime: 'short'}"></kendo-grid-column>
    <kendo-grid-column title="{{'platform.createdBy' | translate}}" field="createdBy" [editable]="false"></kendo-grid-column>
    @if (userService.hasAnyRole([roles.PlatformWrite]) | async) {
      <kendo-grid-command-column title="{{'common.edit' | translate}}" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem let-isNew>
          <div class="center">
            <button kendoGridEditCommand>
              <svg class="icon"><use xlink:href="/assets/icons/symbol-defs.svg#icon-icons-edit"></use></svg>
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    }
    @if (userService.hasAnyRole([roles.PlatformWrite]) | async) {
      <kendo-grid-command-column title="{{'common.remove' | translate}}" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="center">
            <button kendoGridRemoveCommand>
              <svg class="icon"><use xlink:href="/assets/icons/symbol-defs.svg#icon-icons-delete"></use></svg>
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    }
  </kendo-grid>